export default __webpack_public_path__ + "static/media/engaged.2057cdc0.svg";